import React from 'react';

const RegulatoryUpdateIcon = () => {
  return (
    <>
      <svg
        width="33"
        height="33"
        viewBox="0 0 33 33"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 13.75V33H33V13.75H0ZM16.5 30.25C14.6602 30.25 12.914 29.5048 11.6407 28.2343L9.625 30.25V25.4375C9.625 25.058 9.933 24.75 10.3125 24.75H15.125L13.5836 26.2914C14.3481 27.0531 15.3959 27.5 16.5 27.5C18.2903 27.5 19.8027 26.3464 20.372 24.75H23.2361C22.5968 27.8836 19.8206 30.25 16.5 30.25ZM23.375 21.3125C23.375 21.692 23.067 22 22.6875 22H17.875L19.4164 20.4586C18.6519 19.6969 17.6041 19.25 16.5 19.25C14.7098 19.25 13.1973 20.4036 12.628 22H9.76388C10.4032 18.8664 13.1794 16.5 16.5 16.5C18.3398 16.5 20.086 17.2452 21.3593 18.5157L23.375 16.5V21.3125ZM0 11V6.875C0 4.60075 1.85075 2.75 4.125 2.75H8.25V0H11V2.75H22V0H24.75V2.75H28.875C31.1493 2.75 33 4.60075 33 6.875V11H0Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export default RegulatoryUpdateIcon;
